import React from 'react';

import { VerdeLogo } from '../../Atoms';

export default function AcChargers() {
  return (
    <>
      <section>
        <section className="relative overflow-hidden">
          <section className=" max-w-xl lg:max-w-7xl mx-auto w-11/12 px-2 md:px-4">
            <h3 className="text-center font-gilroy">
            Reliable and Future-Ready EV Charging Products
            </h3>
          </section>
        </section>
      </section>
    </>
  );
}
